var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('object',{attrs:{"data":_vm.invoiceData,"type":"application/pdf","width":840,"height":1200}},[_c('embed',{attrs:{"src":_vm.invoiceData,"type":"application/pdf","width":840,"height":1200,"frameBorder":"0","scrolling":"auto"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }